import "./Footer.css"
import FooterLogo from "./FooterLogo.svg"

import {FlexItem, FlexLayout, Link} from "@salt-ds/core";
import Constants from '../Constants';


export default function Footer() {
    return (<>
        <footer className="footer" role="contentinfo">

            <FlexLayout className="footer-content">
                <FlexItem className="footer-logo">
                    <img className="pnet-footer-logo-img" src={FooterLogo}
                         alt="PaymentNet Logo, Image"/>
                </FlexItem>
                <FlexItem className={"footer-link"}>
                    <FlexLayout wrap={true} className={"footer-link-inner"}>
                        <FlexItem>
                            <Link href={"/help/auth/Log_In_Portal/Log_In_Screen/Customer_Service.htm"} IconComponent={null}
                                  target="_blank"><span
                                className="footer-link-text" > {Constants.customerService} </span></Link>
                        </FlexItem>
                        <span className="separator">|</span>
                        <FlexItem>
                            <Link href="http://www.jpmorgan.com/pages/privacy" IconComponent={null} data-testid="privacy-policy-link"
                                  target="_blank"><span className="footer-link-text">{Constants.footerPrivacy}</span><span className="sr-only">{Constants.newWindowAdaSrOnly}</span>
                            </Link>
                        </FlexItem>
                        <span className="separator">|</span>
                        <FlexItem>
                            <Link href="http://www.jpmorgan.com/pages/terms" IconComponent={null}
                                  target="_blank"><span className="footer-link-text">{Constants.footerTerms}</span>
                            </Link>
                        </FlexItem>
                        <span className="separator">|</span>
                        <FlexItem>
                            <Link href="/help/auth/PaymentNet_Security_Best_Practices/PaymentNet_Security_Best_Practices.htm" IconComponent={null}
                                  target="_blank"><span className="footer-link-text">{Constants.footerSecurityBestPractices}</span>
                            </Link>
                        </FlexItem>
                    </FlexLayout>
                </FlexItem>
                <FlexItem className="footer-copyright-container">
                    {Constants.footerCopyRight(new Date().getFullYear())}
                </FlexItem>
            </FlexLayout>

        </footer>
    </>);
}